import { Routes, RouterModule } from '@angular/router';
import { PaymentCheckScreenComponent } from './payment-check.component';

const paymentCheckRoutes: Routes = [
];

export const PaymentCheckRouter = RouterModule.forChild(paymentCheckRoutes);